import { Component } from '@angular/core';
import { ConstantService } from '../../services/constant.service';
import { UtilService } from '../../services/util.service';
import { CommonModule, DatePipe } from '@angular/common';
import { clevertapPush } from '../../services/modification-common.service';
import { DerivativeDetailsService } from '../../services/derivative-details.service';
import { FetchClientInfo_V1Req, SegmentDetailsReq,PushSegmentReq, PushSegment2Req } from '../../models/request.model';
import { UserSessionService } from '../../services/user-session.service';
import { Router } from '@angular/router';
import { MaterialModule } from '../../material.module';
import { EncryptionService } from '../../services/encryption.service';
import { CommonService } from '../../services/common.service';
import { FormControl } from '@angular/forms';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { WarningPopupComponent } from '../../components/warning-popup/warning-popup.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';


@Component({
  selector: 'app-derivative-details',
  imports: [MaterialModule,CommonModule],
  templateUrl: './derivative-details.component.html',
  styleUrl: './derivative-details.component.less'
})
export class DerivativeDetailsComponent {
  dematAccountNo!: string;
  btnloader:boolean = false;
  segmentListNSelected: any[] = [];
    isUserallowed: any;
    camsMode!:string;

  annualIncomeList = [
    {
        id: 1,
        ammout: 'Below 1 Lac',
        values: 'Below 1 Lac'
    },
    {
        id: 2,
        ammout: '1 - 5 Lac',
        values: '1Lac-5Lac'
    },
    {
        id: 3,
        ammout: '5 - 10 Lac',
        values: '5Lac-10Lac'
    },
    {
        id: 4,
        ammout: '10 - 25 Lac',
        values: '10Lac-25Lac'
    },
    {
        id: 5,
        ammout: '25 - 50 Lac',
        values: '25Lac-50Lac'
    },
    {
        id: 6,
        ammout: '50 Lac - 1 Cr',
        values: '50Lac-1Cr'
    },
    {
        id: 7,
        ammout: 'More than 1 Cr',
        values: 'Above 1Cr'
    }
];
    annualIncomeControl = new FormControl(2);

    segmentListSelected: any = [
      {
          id: 'isBseMf',
          segmentName: 'Mutual Fund (BSE)',
          isActive: false
      },
      {
          id: 'isMCXFO',
          segmentName: 'Commodity (MCX)',
          isActive: false
      },
      {
          id: 'isNSECurrency',
          segmentName: 'Currency (NSE)',
          isActive: false
      },
      {
          id: 'isNSEFO',
          segmentName: 'Futures & Options (NSE)',
          isActive: false
      },
      {
          id: 'isBSEFO',
          segmentName: 'Futures & Options (BSE)',
          isActive: false
      },
      {
          id: 'isNSECash',
          segmentName: 'Cash (NSE)',
          isActive: false
      },
      {
          id: 'isBSECash',
          segmentName: 'Cash (BSE)',
          isActive: false
      }
  ];
    clientStatus: string = 'A';
    dpholding: any;
    btnText: string = 'Continue';
    selectedAmount: string = '';

  constructor(
    private constantService: ConstantService,
    private utilService: UtilService,
    private datePipe: DatePipe,
    private router: Router,
    private derivativeDetailsService: DerivativeDetailsService,
    private userSessionService : UserSessionService ,
    private encryptionService: EncryptionService,
    private commonService : CommonService, 
    private _snackbar  : MatSnackBar,
    private matDialog : MatDialog,
    private matBottomSheet :MatBottomSheet
  ) {}

  async ngOnInit() {
    clevertapPush('ActivateDerivative_Initiate', {});
    this.updateSelectedAmount(this.annualIncomeControl.value);
    this.annualIncomeControl.valueChanges.subscribe(value => {
      this.updateSelectedAmount(value);
    });
    this.segmentDetails();
  }
  updateSelectedAmount(selectedId: number | null) {
    if (selectedId === null) {
      this.selectedAmount = '';
      return;
    }
    const selected = this.annualIncomeList.find(item => item.id === selectedId);
    this.selectedAmount = selected ? selected.values : '';
  }
    
    isFinbox: boolean = false;

  async segmentDetails() {
    this.btnloader = true;
    const checksum =  this.userSessionService.getUserSessionData().clientCode + 'PWAWEB' + this.userSessionService.getUserSessionData().ip+this.utilService.checkSumDate      
    const segmentDetailsReq:SegmentDetailsReq  = {
        ipAddress:this.userSessionService.getUserSessionData().ip,
        appSource:"PWAWEB",
        checkSumValue: this.utilService.GenerateCheckSum(checksum,'PWAWEB'),
        clientCode:  this.userSessionService.getUserSessionData().clientCode
    };
    this.derivativeDetailsService.segmentDetails(segmentDetailsReq).subscribe({next : (response) => {
    this.dematAccountNo = response.data.dpAccountNo 
        this.clientStatus = response.data.clientStatus;
        this.dpholding = response.data.totalHolding;
        this.camsMode = response.data.camsMode;
        this.isFinbox = response.data.finbox;
        this.btnText = this.dpholding >= 5000 ? 'Submit' : 'Continue';
        if(response.data.isNSEFO == 'Y' && response.data.isBSEFO == 'Y'){
            if(!response.data.requestAllowed){
            this.router.navigate(['/derivative/successfull-request'],{
            queryParams: {
                header: `Great News! 🎉`,
                msgLine1: `Your NSE & BSE Derivatives segments are now active.\nStart exploring FNO360 on 5paisa and enjoy a seamless trading experience!`,
            }
            })
            }else {
            this.router.navigate(['/derivative/successfull-request'],{
            queryParams: {
                header: `You're Almost There!`,
                msgLine1: `Your NSE & BSE Derivatives segments will be activated within 24 hours.\nGet ready to experience smart trading with FNO360 by 5paisa!`,
            }
            })
            }
        }else{
            this.segmentListLogic(response)
        }
    }, error: (err) => {
        this.btnloader = false;
        this._snackbar.openFromComponent(SnackbarComponent, {
                  data: [err.error.msg],
                  duration: this.constantService.snackBarDuration,
                  panelClass: ['failed-popup']
              });

    }})
}

  segmentSelect(index : any, isActive :boolean) {
      this.segmentListNSelected[index].isActive = isActive ? false : true;
  }

 

  segmentListLogic(response:any){
      this.btnloader = false;
     
      this.isUserallowed =
          response.data.isNSECash == 'Y' && response.data.isBSECash == 'Y' ? true : false;

        if(!this.isUserallowed){
            this.openWarningDailog()
        }

        for (const key in response.data) {
          this.segmentListSelected = this.segmentListSelected.map((item : any) => {
              if (key === item.id) {
                  item.isActive = response.data[key] == 'Y' ? true : false;
              }
              return item;
          });
      }
      this.segmentListSelected.forEach((item : any) => {
          if (item.isActive == false) {
              this.segmentListNSelected.push(item);
          }
      });
      this.segmentListNSelected = JSON.parse(JSON.stringify(this.segmentListNSelected));
      this.segmentListNSelected.forEach((item) => {
          item.isActive = true;
      });
      if (this.segmentListNSelected.length == 0) {
          this.router.navigate(['/derivative/successfull-request'],{ queryParams: { success: 'true' }});
      }
  }
  showMore: boolean = false;

toggleKnowMore() {
  this.showMore = !this.showMore;
}
  submit() {
    this.btnloader = true;
    clevertapPush('Segment_Activation_MOD', {
        parameter1: 'MOD_SEG_ACT_WEBVIEW',
        parameter2: 'Segment_Details'
    });
    if (this.dpholding >= 5000) {
        this.getPushSegment2();
    } else {
        clevertapPush('Segment_Activation_MOD', {
            income_slab: this.selectedAmount,
            action: 'MOD_SEG_FIN_MANUAL'
        });
        const index = this.annualIncomeControl.value || 2
        localStorage.setItem('salarySlab', JSON.stringify(this.annualIncomeList[parseInt(index.toString())-1
        ]));
        localStorage.setItem(
            'dematAccountNo',
            this.encryptionService.encryptUsingAES256AndRFC2898(this.dematAccountNo)
        );
        this.router.navigate(['/derivative/proof-selection'], { queryParams: { camsMode: this.camsMode,finbox:this.isFinbox } });
    }
}

getPushSegment() {
    const  appSource = 'CLIENTWEB'
    const todayDt = this.datePipe.transform(new Date(), this.constantService.checksumDateFormate);
    const parameter = this.userSessionService.getUserSessionData().clientCode + appSource + this.userSessionService.getUserSessionData().ip+ todayDt;
    const checkSumValue = this.utilService?.GenerateCheckSum(parameter,appSource);
    const pushSegmentReq : PushSegmentReq = {
        head: {
            ipAddress: this.userSessionService.getUserSessionData().ip,
            appSource: appSource,
            checkSumValue: checkSumValue
        },
        body: {
            typeOfModification: '1',
            clientCode: this.userSessionService.getUserSessionData().clientCode,
            dpAccountNo: this.dematAccountNo,
            incomeSlab: this.selectedAmount,
            proofCode1: '22',
            proofCode2: '0',
            img_Proof1: '',
            img_Proof2: '',
            imgType1: '',
            imgType2: ''
        }
    };

    this.commonService.PushSegment(pushSegmentReq).subscribe({next:(responce)=>{
      const data = {
          income_range: this.selectedAmount
      };
      clevertapPush('Segment_Activation_MOD', data);
      this.router.navigateByUrl('/derivative/successfull-request');
    },error:(err)=>{
     
    }})
}

getPushSegment2() {
    //  clientCode + ipAddress +  appSource (UPPER CASE) + incomeSlab
      const parameter = this.userSessionService.getUserSessionData().clientCode +this.userSessionService.getUserSessionData().ip +this.userSessionService.getUserSessionData().appSource.toUpperCase() + this.selectedAmount + this.utilService.checkSumDate;
      const pushSegment2Req : PushSegment2Req = {
        ipAddress: this.userSessionService.getUserSessionData().ip,
        appSource: this.userSessionService.getUserSessionData().appSource,
        checkSumValue:this.utilService.GenerateCheckSum(parameter),
        clientCode: this.userSessionService.getUserSessionData().clientCode,
        typeOfModification:'1',
        incomeSlab: this.selectedAmount,
        dpAccountNo:  this.dematAccountNo,
        proofCode1:  '22',
        imageProof1: '',
        imageType1:  '',
        proofCode2: '0',
        imageProof2: '',
        imageType2: ''
    };

      this.commonService.PushSegment2(pushSegment2Req).subscribe({next:(responce)=>{
       const data = {
          income_range: this.selectedAmount
      };
      clevertapPush('Segment_Activation_MOD', data);
      this.router.navigateByUrl('/derivative/successfull-request');
      },error:(err)=>{
      this.btnloader= false;
      const message = err.error.message
                  if ( err.error.status == 2 || err.error.httpCode == 422) {
                           this._snackbar.openFromComponent(SnackbarComponent, {
                  data: [message],
                  duration: this.constantService.snackBarDuration,
                  panelClass: ['failed-popup']
              });
              this.router.navigateByUrl('/derivative/fail-page');
            }
      }})
}

openWarningDailog(){
     const isMobile = window.innerWidth <= 768;
    if(isMobile){
        this.matBottomSheet.open(WarningPopupComponent,{
        disableClose: true
      })
    }else{
        this.matDialog.open(WarningPopupComponent,{
        panelClass: 'custom-dialog-container',
        disableClose: true
      })
    }  
}


}
